import { Set } from "immutable";

import JavascriptParser from "./parser/JavascriptParser";

function runTest(testContent, mocks, mockableFunctions, files, hiddenFiles) {
    let lastRequireIndex = testContent.lastIndexOf("require");
    let insertMocksIndex = testContent.indexOf("\n", lastRequireIndex);
    testContent = testContent.slice(0, insertMocksIndex) + 
                  "\n\n" +
                  createMocksSection(mocks, mockableFunctions) + 
                  testContent.slice(insertMocksIndex);
    try {
        let fullTest = unwind(testContent, files, hiddenFiles);
        eval(fullTest);
    } catch (e) {
        return e;
    }
    return null;
}

function createMocksSection(mocks, mockableFunctions) {
    let mockFunctionStrings = [];
    for (var property in mocks) {
        if (mocks.hasOwnProperty(property)) {
            let content = mocks[property];
            if (content === "") {
                continue;
            }

            let parts = property.split('.');
            let name = property;
            let className = null;
            if (parts.length !== 1) {
                className = parts[0];
                name = parts[1];
            }

            let matchingMockableFunctions = mockableFunctions.filter(mockableFunction => {
                return mockableFunction.name === name && mockableFunction.className === className;
            });

            if (matchingMockableFunctions.length !== 1) {
                continue;
            }

            let mockableFunction = matchingMockableFunctions[0];

            if (mockableFunction.className != null) {
                mockFunctionStrings.push(className + ".prototype."+name+" = function ("+ mockableFunction.parameters + ") {\n" +
                content +
                "\n}" + "\n\n" + className + "."+name+" = function ("+ mockableFunction.parameters + ") {\n" +
                content +
                "\n}");
            } else {
                mockFunctionStrings.push("function "+property+"(" + mockableFunction.parameters + ") {\n" +
                    content +
                    "\n}");
            }
        }
    }
    return mockFunctionStrings.join("\n\n");
}

function unwind(testContent, files, hiddenFiles) {
    let unwoundContent = testContent;
    let visited = Set();
    while (true) {
        const importRegex = /require\s*\(\s*['"](\.\/)?([\w-]+)['"]\s*\)/g;
        const match = importRegex.exec(unwoundContent);
        if (match == null) {
            break;
        }
        const hiddenFile = match[1] == null;
        const filename = match[2] + '.js';
        const matchingFiles = files.filter(file => {
            let isHidden = hiddenFiles != null && 
                hiddenFiles.some(hiddenFilename => file.filename === hiddenFilename);
            let hiddenMatches = (isHidden && hiddenFile) || (!isHidden && !hiddenFile);
            return hiddenMatches && file.filename === filename;
        });
        if (matchingFiles.length !== 1) {
            let errorMessage = "Unable to find file " + filename;
            if (hiddenFile) {
                errorMessage = "Unable to find library " + match[2];
            }
            throw new ReferenceError(errorMessage);
        }
        let prefix = "\\.\\/";
        if (hiddenFile) {
            prefix = "";
        }
        const replaceRegex = new RegExp("require\\s*\\(\\s*['\"]" + prefix + match[2] +"['\"]\\s*\\)(;)?");
        let content = matchingFiles[0].content;
        if (visited.has(filename)) {
            content = "";
        }
        unwoundContent = unwoundContent.replace(replaceRegex, content);
        visited = visited.add(filename);
    } 
    return unwoundContent;
}

function supportChangingStatic(content) {
    let functions = JavascriptParser.getFunctions([content]);
    functions.forEach(func => {
        if (func.className == null) {
            return;
        }
        if (func.isStatic) {
            content = content.replace(func.className + ".prototype." + func.name, func.className + "." + func.name);
        } else {
            content = content.replace(func.className + "." + func.name, func.className + ".prototype." + func.name);
        }
    });
    return content;
}

export { runTest }


// WEBPACK FOOTER //
// ./src/TestRunner.js